/**
 * Destinazione post-logout Cognito: nessuna UI, redirect immediato alla Hosted UI login.
 */
import { useLayoutEffect } from "react";

import { authDisabled, cognitoConfigured } from "@/lib/authConfig";
import { useAuth } from "@/lib/AuthProvider";

export function AuthExit() {
  const auth = useAuth();

  useLayoutEffect(() => {
    if (!auth.ready) return;
    if (auth.authenticated) {
      window.location.replace("/");
      return;
    }
    if (authDisabled || !cognitoConfigured()) {
      window.location.replace("/login");
      return;
    }
    void auth.login();
  }, [auth.ready, auth.authenticated, auth]);

  return null;
}
